export default __webpack_public_path__ + "static/media/Otros.bd6672aa.svg";